import { Link, RadioField, RadioInput } from '@flos/react-ui';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { allCoverablesOnsaAtom } from '../../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCurrentProductSelector } from '../../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { useUpdateCoverableInformation } from '../../../../../recoil/hooks/useUpdateCoverableInformation';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { COVERABLE_CODE } from '../../../../../constants/coverable';
import ViewInformationModal from '../../../../../shared_components/ViewInformationModal/ViewInformationModal';

const HouseForeclosureQuestion = (): React.JSX.Element => {
    const getHippoText = useHippoText();
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const houseCoverables =
        currentProduct.flavourCode === COVERABLE_CODE.prhHouse
            ? coverables.houses ?? []
            : coverables.holidayHomes ?? [];
    const coverableIndex = houseCoverables?.findIndex(
        (coverable) => coverable.fixedId === currentProduct.fixedId
    );
    const currentHouseCoverable = houseCoverables[coverableIndex];

    const getInitalState = (): string => {
        if (
            currentHouseCoverable.previousOwnerDeceased &&
            currentHouseCoverable.foreclosureAuction === false
        )
            return 'previousOwnerDeceased';
        if (
            currentHouseCoverable.foreclosureAuction &&
            currentHouseCoverable.previousOwnerDeceased === false
        )
            return 'foreclosureAuction';
        if (currentHouseCoverable.previousOwnerDeceased && currentHouseCoverable.foreclosureAuction)
            return 'Both';
        if (
            currentHouseCoverable.foreclosureAuction === false &&
            currentHouseCoverable.previousOwnerDeceased === false
        )
            return 'Neither';
        return '';
    };

    const [choice, setChoice] = useState<string>(getInitalState());
    const [showModal, setShowModal] = useState<boolean>(false);

    const handleChoiceChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = event.target;
        setChoice(value);
        updateCoverableInformation({
            previousOwnerDeceased: value === 'previousOwnerDeceased' || value === 'Both',
            foreclosureAuction: value === 'foreclosureAuction' || value === 'Both'
        });
    };

    return (
        <div className="u-spacing-inset-m--stretch-max">
            <h4>{getHippoText('DSS-ADDITIONAL-INFORMATION-FORECLOSUREORDECEASED-TITLE')}</h4>
            <RadioField value={choice} onChange={handleChoiceChange}>
                <RadioInput label={'Dødsbo'} value="previousOwnerDeceased" />
                <RadioInput label={'Tvangsauktion'} value="foreclosureAuction" />
                <RadioInput label={'Både dødsbo og tvangsauktion'} value="Both" />
                <RadioInput label={'Ingen af delene'} value="Neither" />
            </RadioField>
            <Link
                onClick={() => {
                    setShowModal(true);
                }}
                theme="logo"
            >
                {getHippoText('DSS-ADDITIONAL-INFORMATION-INFOLINK')}
            </Link>
            {showModal && (
                <ViewInformationModal
                    showModal={showModal}
                    modalProps={{
                        title: getHippoText('DSS-ADDITIONAL-INFORMATION-INFOLINK'),
                        description: getHippoText('DSS-ADDITIONAL-INFORMATION-INFOLINK-FORECLOSURE')
                    }}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                />
            )}
        </div>
    );
};

export default HouseForeclosureQuestion;
